import { gql } from "@apollo/client";

export type VP1801Info = {
	id: string
	ipAddress: string
	port: number
	lastHeartbeat: number
	macAddress?: string
	antenna1TagInfo?: VP1801AntennaTagInfo
	antenna2TagInfo?: VP1801AntennaTagInfo
	firstConnectionAt: number
}

export type VP1801AntennaTagInfo = {
	tag: string
	dataBit: number
	animalBit: number
	type: number
	strength: number
	retaggingCounter?: number
	userInfo?: number
	reservedField?: number
	seenAt: number
}

export const CONNECTED_1801_DEVICES = gql`
query Connected1801Devices($domain: String!, $ids: [String!]) {
	device {
		connected1801Devices(domain: $domain, ids: $ids) {
			id
			ipAddress
			port
			lastHeartbeat
			macAddress
			antenna1TagInfo {
				tag
				dataBit
				animalBit
				type
				strength
				retaggingCounter
				userInfo
				reservedField
				seenAt
			}
			antenna2TagInfo {
				tag
				dataBit
				animalBit
				type
				strength
				retaggingCounter
				userInfo
				reservedField
				seenAt
			}
			firstConnectionAt
		}
	}
}
`

export interface Connected1801DevicesResponse {
	device: {
		connected1801Devices: VP1801Info[]
	}
}

export interface Connected1801DevicesArgs {
	domain: string;
	ids?: string[];
}

